module.exports = __webpack_public_path__ + "static/heart_blue-e689a99689d7cfefc82e5d8eaa7c2195.svg";